<template>
    <div class="inline-block">

            <input id="turnOff"
                    type="hidden"
                    :value="1"
            />
              <button id="turnAdminOff" @click="adminOff" type="submit" class="rounded-full ml-3 pr-3 pl-2 py-1 text-xxs font-bold bg-gray-600"><i aria-hidden="true" class="material-icons text-base align-bottom pl-0">power_off</i>Disable Admin Authorization</button>
        
      </div>
</template>

<script>
import axios from 'axios'

  export default {

        props: {
            content: '',
            route:'',

        },

        data() {
          return {
            success: false,
            loaded: true,
            value:''
          }
        },

        methods: {
          adminOff: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( "#turnAdminOff").addClass( "loading" );
              axios.put(this.route,
                {
                    admin: '0'
                }
              ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
